import React, { useContext, useEffect, useRef, useState, type JSX } from 'react';

const initialCanPlayWebmContextState = {
  canPlayWebm: null,
};

interface ContextShape {
  canPlayWebm: CanPlayTypeResult | null;
}

const CanPlayWebmContext = React.createContext<ContextShape>(initialCanPlayWebmContextState);

export const CanPlayWebmContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const [canPlayWebm, setCanPlayWebm] = useState<CanPlayTypeResult | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current && canPlayWebm === null) {
      setCanPlayWebm(videoRef.current.canPlayType('video/webm;'));
      videoRef.current.remove();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoRef]);

  return (
    <CanPlayWebmContext.Provider
      value={{
        canPlayWebm,
      }}
    >
      {}
      <video ref={videoRef} />
      {children}
    </CanPlayWebmContext.Provider>
  );
};

export const useCanPlayWebmContext = (): ContextShape => useContext(CanPlayWebmContext);
